// import { PagedResult } from "../../interfaces/PagedResult";

import { ApiResponse, PagedResults } from "../../interfaces/genericResponse/GenericResponse";
import { EmergencyEventDto, EmergencySurveyTriggerRequestDto, EmergencySurveyTriggerResponseDto, GetSubmitedEmployeeSurveyRequest, GetSubmitedEmployeeSurveyResponseDto, SurveyInstanceResponseDto, SurveyResponseResultDto, SurveyStatusItemDto, SurveyStatusRequestDto } from "../../interfaces/survey/SurveyDtos";

// import { PagedResult } from "../../interfaces/signature/SignatureRequestDto";

export async function GetEmergencySurveyStatusListAsync(
    authToken: string,
    pageNumber: number,
    pageSize: number,
    participantId: number = 0,
): Promise<ApiResponse<PagedResults<SurveyStatusItemDto>>> {
    try {
        const apiUrl: string = `${process.env.REACT_APP_API_BASE_URL}/surveys/status`;

        const payload: SurveyStatusRequestDto = {
            participantId: participantId,
            pageNumber: pageNumber,
            pageSize: pageSize
        }

        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${authToken}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload)
        });

        const responseBody = await response.json();
        return responseBody;
    } catch (error) {
        throw new Error(`Failed to upload file: ${error instanceof Error ? error.message : String(error)}`);
    }
}


export async function SaveServeyResponse(
    authToken: string,
    responseData: any,
    instanceId: string
): Promise<ApiResponse<SurveyResponseResultDto>> {
    try {
        const apiUrl: string = `${process.env.REACT_APP_API_BASE_URL}/surveys/${instanceId}/responses`;

        const payload = {
            responseData: JSON.stringify(responseData)
        }

        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${authToken}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload)
        });

        const responseBody = await response.json();
        return responseBody;
    } catch (error) {
        throw new Error(`Failed to upload file: ${error instanceof Error ? error.message : String(error)}`);
    }
}


export async function GetSurveyResponseAsync(
    authToken: string,
    instanceId: string
): Promise<ApiResponse<SurveyInstanceResponseDto>> {
    try {
        const apiUrl: string = `${process.env.REACT_APP_API_BASE_URL}/surveys/instances/${instanceId}/response`;

        const response = await fetch(apiUrl, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${authToken}`,
                'Content-Type': 'application/json',
            },
        });

        const responseBody = await response.json();
        return responseBody;
    } catch (error) {
        throw new Error(`Failed to upload file: ${error instanceof Error ? error.message : String(error)}`);
    }
}

export async function TriggerEMERGENCY_SURVEY_1Async(
    authToken: string,
    payload: EmergencySurveyTriggerRequestDto,
): Promise<ApiResponse<EmergencySurveyTriggerResponseDto>> {
    try {
        const apiUrl: string = `${process.env.REACT_APP_API_BASE_URL}/surveys/trigger`;

        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${authToken}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload)
        });

        const responseBody = await response.json();
        return responseBody;
    } catch (error) {
        throw new Error(`Failed to upload file: ${error instanceof Error ? error.message : String(error)}`);
    }
}

export async function TriggerEMERGENCY_SURVEY_3Async(
    authToken: string,
    payload: EmergencySurveyTriggerRequestDto,
): Promise<ApiResponse<EmergencySurveyTriggerResponseDto>> {
    try {
        const apiUrl: string = `${process.env.REACT_APP_API_BASE_URL}/surveys/poststromtrigger`;

        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${authToken}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload)
        });

        const responseBody = await response.json();
        return responseBody;
    } catch (error) {
        throw new Error(`Failed to upload file: ${error instanceof Error ? error.message : String(error)}`);
    }
}


export async function GetSurveyDetailsbyInstanceIdAsync(
    authToken: string,
    instanceId: string,
): Promise<ApiResponse<EmergencyEventDto>> {
    try {
        const apiUrl: string = `${process.env.REACT_APP_API_BASE_URL}/surveys/by-instance/${instanceId}`;

        const response = await fetch(apiUrl, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${authToken}`,
                'Content-Type': 'application/json',
            },
        });

        const responseBody = await response.json();
        return responseBody;
    } catch (error) {
        throw error;
    }
}

export async function GetSubmitedEmployeeSurveyAsync(
    authToken: string,
    userId : string,
    pageNumber : number,
    pageSize : number
): Promise<ApiResponse<PagedResults<GetSubmitedEmployeeSurveyResponseDto>>> {
    try {
        const apiUrl: string = `${process.env.REACT_APP_API_BASE_URL}/surveys/get-submited-employeesurvey`;
        const payload: GetSubmitedEmployeeSurveyRequest = {
            userId: userId,
            pageNumber: pageNumber,
            pageSize: pageSize
        }
        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${authToken}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload)
        });

        const responseBody = await response.json();
        return responseBody;
    } catch (error : any) {
        throw error;
    }
}